require('./files/pop-ups-smarter-click');
require('../../sass/web/pop-ups-smarter-click.scss');